const transformGroups = new WeakMap();

export { transformGroups };
//# sourceMappingURL=groups.mjs.map
